/**
 * Include your custom JavaScript here.
 * (Theme hooks: 'variant:changed', 'product:added', 'cart:refresh' events — see Warehouse docs.)
 */

/**
 * M&M Bird Toys — product image lightbox on desktop & iPad (added Oct 2026)
 *
 * Warehouse only opens its full-screen image viewer (PhotoSwipe) on screens under 1024px,
 * and uses a hover zoom box on larger screens. This makes desktop/iPad behave like mobile:
 *  - the hover zoom box is hidden
 *  - clicking/tapping a product image opens the same full-screen viewer (arrows, Esc, swipe)
 * Requires "Enable image zoom" to stay ON in the product page settings.
 */
(function () {
  var style = document.createElement('style');
  style.textContent =
    '.drift-zoom-pane, .drift-bounding-box { display: none !important; }' +
    '@media screen and (min-width: 1024px) { .product-gallery__carousel--zoomable .product-gallery__image { cursor: zoom-in; } }' +
    /* keep the rewards and chat buttons from floating over the open viewer */
    'html:has(.pswp--open) #smile-ui-lite-container, html:has(.pswp--open) shopify-chat { display: none !important; }';
  document.head.appendChild(style);

  var IMAGE_SELECTOR = '.product-gallery__carousel--zoomable .product-gallery__image';
  var POCKET_QUERY = 'screen and (max-width: 1023px)';
  var LAP_AND_UP_QUERY = 'screen and (min-width: 1024px)';
  var forceMobileViewer = false;

  function fakeQuery(query, matches) {
    return { matches: matches, media: query, onchange: null, addListener: function () {}, removeListener: function () {}, addEventListener: function () {}, removeEventListener: function () {}, dispatchEvent: function () { return false; } };
  }

  // While opening the viewer (and while it is open) the theme is told the screen is "mobile size",
  // so it opens the viewer and does not close it again when an iPad fires a resize event.
  var originalMatchMedia = window.matchMedia;
  window.matchMedia = function (query) {
    if (forceMobileViewer || document.querySelector('.pswp.pswp--open')) {
      if (query === POCKET_QUERY) return fakeQuery(query, true);
      if (query === LAP_AND_UP_QUERY) return fakeQuery(query, false);
    }
    return originalMatchMedia.call(window, query);
  };

  function withMobileViewer(fn) {
    forceMobileViewer = true;
    try { fn(); } finally { setTimeout(function () { forceMobileViewer = false; }, 0); }
  }

  // Desktop: mouse click
  document.addEventListener('click', function (event) {
    var image = event.target.closest && event.target.closest(IMAGE_SELECTOR);
    if (!image || window.innerWidth < 1024) return;
    forceMobileViewer = true;
    setTimeout(function () { forceMobileViewer = false; }, 0);
  }, true);

  // iPad / large touch screens: handle the tap directly, because Safari turns the first tap
  // into a "hover" for the hidden zoom box and never sends the click.
  var touchStart = null;
  document.addEventListener('touchstart', function (event) {
    var image = event.target.closest && event.target.closest(IMAGE_SELECTOR);
    if (!image || window.innerWidth < 1024 || event.touches.length !== 1) { touchStart = null; return; }
    touchStart = { image: image, x: event.touches[0].clientX, y: event.touches[0].clientY, time: Date.now() };
  }, { passive: true, capture: true });

  document.addEventListener('touchend', function (event) {
    if (!touchStart) return;
    var start = touchStart;
    touchStart = null;
    var touch = event.changedTouches && event.changedTouches[0];
    if (!touch) return;
    var moved = Math.abs(touch.clientX - start.x) > 10 || Math.abs(touch.clientY - start.y) > 10;
    if (moved || Date.now() - start.time > 600) return; // a swipe or long press, not a tap
    event.preventDefault(); // stop Safari's emulated hover/click
    withMobileViewer(function () { start.image.click(); });
  }, { passive: false, capture: true });
})();
